<template>
  <div class="action-plan-form">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <p class="lead m-0">Plano de Ação: Situações</p>
          </div>
        </div>
      </div>

      <div class="row mb-3 no-print">
        <div class="col-12">
          <router-link
            to="/action-plan"
            class="btn btn-success"
          >
            <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
            Voltar ao Plano de Ação
          </router-link>

          <button
            @click="print"
            class="btn btn-primary ml-2"
          >
            <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
            Salvar / Imprimir
          </button>
        </div>
      </div>

      <div class="break-after mt-5">
        <Filter @filter="onFilter" :riskAnalyses="riskAnalyses" />
      </div>

      <div class="paginator" v-if="totalRecords > perPage">
        <Paginator
          :first="(currentPage - 1) * perPage"
          :rows="perPage"
          :total-records="totalRecords"
          @page="onPage($event)"
        ></Paginator>
      </div>

      <div
        class="form-item-holder mb-3"
        v-for="(item, i) in riskAnalyses"
        :key="item.id"
      >
        <form-item
          ref="uploaded-items"
          :risk-analysis="item"
          :index="(currentPage - 1) * perPage + i + 1"
          :filters="fullQueryString"
        ></form-item>
        <div class="loading-panel" v-if="loading">
          <ProgressSpinner />
        </div>
      </div>

      <div class="no-items" v-if="!riskAnalyses || riskAnalyses.length === 0">
        Nenhuma não conformidade encontrada para esta fase
      </div>

      <div class="paginator" v-if="totalRecords > perPage">
        <Paginator
          :first="(currentPage - 1) * perPage"
          :rows="perPage"
          :total-records="totalRecords"
          @page="onPage($event)"
        ></Paginator>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from '@vue/runtime-core'
  import { useRoute } from 'vue-router'

  import FormItem from '../components/FormItem'
  import { useStore } from 'vuex'

  import Paginator from 'primevue/paginator'
  import ProgressSpinner from 'primevue/progressspinner'

  import Filter from '../../common/Filter/Filter.vue'

  export default {
    setup() {
      const store = useStore()
      const { params } = useRoute()

      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)

      const { step } = params

      return {
        selected_company,
        selected_order_of_service,
        step: step,

        params,
      }
    },
    components: {
      FormItem,
      Paginator,
      ProgressSpinner,
      Filter,
    },
    data() {
      return {
        riskAnalyses: [],
        filters: null,
        perPage: 10,
        currentPage: 1,
        totalRecords: null,
        lastPage: null,
        loading: false,
        queryString: '',
        fullQueryString: '',
      }
    },
    methods: {
      loadData(page) {
        const app = this
        page = page || 1

        this.loading = true

        this.queryString = this.getQueryString(page, this.perPage)

        if (this.step) this.queryString += `&phase=${this.step}`

        this.fullQueryString =
          'order_of_service_id=' + this.selected_order_of_service.id + this.queryString

        this.axios
          .get(
            `/api/action-plan/get-by-phase/?&order_of_service_id=${this.selected_order_of_service.id}${this.queryString}`,
          )
          .then(({ data }) => {
            app.riskAnalyses = [...data.data]
            app.totalRecords = data.total
            app.lastPage = data.last_page
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => (this.loading = false))
      },
      getQueryString(page, perPage) {
        let query = ''

        if (page) query += `&page=${page}`

        if (perPage) query += `&perPage=${perPage}`

        if (this.filters) {
          const queryStringFilters = Object.keys(this.filters)
            .filter((key) => this.filters[key])
            .map((key) => key + '=' + this.filters[key])
            .join('&')

          query += `&${queryStringFilters}`
        }

        return query
      },
      onPage(event) {
        const page = event.page + 1
        this.currentPage = page

        this.loadData(page)
      },
      onFilter(event) {
        this.filters = event

        this.loadData(this.currentPage)
      },
      print() {
        window.print()
      },
    },
    mounted() {
      if (this.params?.filters) {
        this.filters = JSON.parse(this.params?.filters)
      }

      this.loadData()
    },
    watch: {
      selected_order_of_service() {
        this.loadData()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .action-plan-form {
    .form-item-holder {
      position: relative;

      .loading-panel {
        position: absolute;
        top: 0;
        left: 0;

        height: 100%;
        width: 100%;

        background-color: #e9ecef;

        display: flex;
        align-items: center;
        justify-content: center;

        opacity: 0.9;
      }
    }
  }

  @media print {
      .paginator {
          visibility: hidden;
      }

      .form-item-holder {
          page-break-after: always;
      }
  }
</style>
